import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as projectDashboardAPI from '../../api/FinanceReportAPI/projectDashboardAPI';

export const fetchProjectDashboardSummary = createAsyncThunk(
    'projectDashboard/fetchProjectDashboardSummary',
    async ({ roleId, userId } = {}, { rejectWithValue }) => {
        try {
            const response = await projectDashboardAPI.getProjectDashboardSummary({ roleId, userId });
            return response?.Data || response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch Project Dashboard Summary');
        }
    }
);

const initialState = {
    summary: null,
    loading: false,
    error: null,
};

const projectDashboardSlice = createSlice({
    name: 'projectDashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjectDashboardSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProjectDashboardSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.summary = action.payload;
            })
            .addCase(fetchProjectDashboardSummary.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectProjectDashboardSummary = (state) => state.projectDashboard.summary;
export const selectProjectDashboardLoading = (state) => state.projectDashboard.loading;

export default projectDashboardSlice.reducer;
